import { EuiLink } from "@elastic/eui";
import React from "react";
import _ from "lodash";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "name",
        name: "Name",
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "taggingsCount",
        name: "Taggings Count",
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "createdAt",
        name: "Creation Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "creatorId",
        name: "Creator id",
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: "Creator email",
        sortable: false,
    },
    {
        field: "creatorType",
        name: "Creator type",
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
